import { IAccountListTableLang } from '../../../types/lang'

export const accountListTableLang: IAccountListTableLang = {
	account_list_table: {
		column_id: 'ID_ru',
		column_email: 'Email_ru',
		column_login: 'Login_ru',
		column_kt_group: 'KT Group_ru',
		column_role: 'Role_ru',
		column_is_buyer: 'Buyer_ru',
		column_in_group: 'Group_ru',
		column_is_team: 'Team_ru',
		column_is_active: 'Active_ru',
		column_is_fired: 'Fired_ru',
		column_date_registered: 'Date Registered_ru',
		column_date_deleted: 'Date Deleted_ru',
	}
}